import React, { useCallback } from 'react';

import { IClick } from '~/src/features/movix-new';
import { ELABELS } from '~/src/features/movix-new/constants';
import { dataLayerPushButton } from '~/src/features/movix-new/utils';

import { MovixButton } from '~/src/features/movix-new/styled';
import * as ST from './styled';

interface IProps {
    handleClick: (data: IClick) => void,
}

const HeaderTitleBlock = ({ handleClick }: IProps): JSX.Element => {

    const handleClickDataLayerWrapper = useCallback(() => {
        handleClick({ label: ELABELS.firstScreen });
        dataLayerPushButton(ELABELS.firstScreen);
    }, []);

    return (<ST.Container>
        <ST.HeaderMainText>
            Ваш домашний<br/>центр развлечений
        </ST.HeaderMainText>
        <ST.SubText>
            Всё и сразу: телеканалы, фильмы и сериалы из популярных онлайн-кинотеатров
            и приложения как на Smart TV в одной приставке
        </ST.SubText>
        <ST.WrapperBottomBlock>
            <ST.ButtonBlock>
                <MovixButton
                    bType={'white'}
                    onClick={handleClickDataLayerWrapper}
                >
                    Подключить в рассрочку
                </MovixButton>
            </ST.ButtonBlock>
            <ST.HeaderLegal>
                Подключите в рассрочку на 6, 12, 24 или 36 месяцев
            </ST.HeaderLegal>
        </ST.WrapperBottomBlock>
    </ST.Container>);
};

export default HeaderTitleBlock;
